<template>
  <div class="cj-form-field">
    <label class="cj-label" v-if="field.type != 'boolean' && field.type != 'attachments'">{{ (field.required)?'* '+field.name:field.name }}</label>

    <validation-provider v-if="field.type != 'attachments'" :name="field.name.toLowerCase()" :rules="{ required: (!readonly && field.required && field.type != 'boolean') }" v-slot="{ errors }">
      <div v-if="field.type == 'short-text'">
        <div v-if="!printable">
          <b-form-input v-model="field.value" type="text" :value="field.default_value" :readonly="readonly" :disabled="readonly" :placeholder="(readonly)?field.default_value:''" :class="{ 'error': errors.length > 0 }"></b-form-input>
        </div>
        <div v-else>
          <nl2br tag="p" :text="field.value" class-name="mb-0" />
        </div>
      </div>

      <div v-else-if="field.type == 'date'">
        <div v-if="!printable">
          <date-picker v-model="field.value" name="date" v-mask="'##/##/####'" :readonly="readonly" :disabled="readonly" :placeholder="(readonly)?field.default_value:''" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }"></date-picker>
        </div>
        <div v-else>
          <nl2br tag="p" :text="field.value" class-name="mb-0" />
        </div>
      </div>

      <div v-else-if="field.type == 'long-text'">
        <div v-if="!printable">
          <b-form-textarea v-model="field.value" :value="field.default_value" :readonly="readonly" :disabled="readonly" :placeholder="(readonly)?field.default_value:''" :rows="(!printable)?field.rows:null" :class="{ 'error': errors.length > 0 }"></b-form-textarea>
        </div>
        <div v-else>
          <nl2br tag="p" :text="field.value" class-name="mb-0" />
        </div>
      </div>

      <div v-else-if="field.type == 'boolean'">
        <div v-if="!printable">
          <label class="cj-label w-100">&nbsp;</label>
          <div class="pretty p-switch p-fill" :class="{ 'p-locked': readonly }">
            <input type="checkbox" v-model="field.value" />
            <div class="state p-success">
              <label><span>{{ field.name }}</span></label>
            </div>
          </div>
        </div>
        <div v-else>
          <label class="cj-label">{{ field.name }}</label>
          <div class="row">
            <div class="col d-flex align-items-center">
              <span class="checkbox" :class="{ 'filled': (field.value != null && field.value != '' && field.value) }"></span> <span>Sim</span>
            </div>
            <div class="col d-flex align-items-center">
              <span class="checkbox" :class="{ 'filled': (field.value != null && field.value != '' && !field.value) }"></span> <span>Não</span>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="field.type == 'list'">
        <div v-if="!printable">
          <multiselect v-model="field.value" :options="getFieldOptions(field)" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione" :disabled="readonly" :class="{ 'error': errors.length > 0 }"></multiselect>
        </div>
        <div v-else>
          <label class="cj-label">{{ field.name }}</label>
          <ul class="mb-0">
            <li class="d-flex align-items-center" v-for="(option, index) of getFieldOptions(field)" :key="index">
              <span class="checkbox" :class="{ 'filled': option == field.value }"></span> <span>{{ option }}</span>
            </li>
          </ul>
        </div>
      </div>

      <b-form-checkbox-group v-model="field.value" v-else-if="field.type == 'multiple-choice'">
        <div v-if="!printable">
          <b-list-group>
            <b-list-group-item v-for="(option, index) of getFieldOptions(field)" :key="index">
              <b-form-checkbox :readonly="readonly" :disabled="readonly" :value="option" :class="{ 'error': errors.length > 0 }">{{ option }}</b-form-checkbox>
            </b-list-group-item>
          </b-list-group>
        </div>
        <div v-else>
          <label class="cj-label">{{ field.name }}</label>
          <ul class="mb-0">
            <li class="d-flex align-items-center" v-for="(option, index) of getFieldOptions(field)" :key="index">
              <span class="checkbox" :class="{ 'filled': field.value.includes(option) }"></span> <span>{{ option }}</span>
            </li>
          </ul>
        </div>
      </b-form-checkbox-group>

      <span class="cj-error">{{ errors[0] }}</span>
    </validation-provider>

    <div v-if="field.type == 'attachments'">
      <div v-if="!printable && !preview">
        <b-row class="mb-2" v-for="(attachment, index) of field.value" :key="index">
          <b-col>
            <label class="cj-label">{{ field.name }} {{index + 1}}</label>
            <b-form-file v-model="attachment.selected_file" @input="attachmentChanged(field, index)" :placeholder="attachment.file_name || ''" :readonly="readonly" :disabled="readonly"></b-form-file>
          </b-col>
          <b-col>
            <label class="cj-label">{{ field.name }} {{index + 1}} - Nome/descrição</label>
            <b-form-input v-model="attachment.name" type="text" :value="attachment.name" :readonly="readonly" :disabled="readonly"></b-form-input>
          </b-col>
          <b-col cols="1" v-if="!readonly">
            <label class="cj-label">&nbsp;</label>
            <b-button class="delete-attachment" variant="danger" @click="removeAttachment(field, index)"><i class="far fa-trash-alt"></i></b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="mt-1 text-center">
            <b-button variant="dark" @click="addAttachment(field)" :readonly="readonly" :disabled="readonly">Adicionar {{ field.name }}</b-button>
          </b-col>
        </b-row>
      </div>
        <div v-else>
          <b-row class="mb-2" v-for="(attachment, index) of field.value" :key="index">
            <b-col cols="12" class="attachment-label">
              <label class="cj-label">{{ field.name }} {{index + 1}}</label>
            </b-col>
            <div class="attachment-container">
              <a :href="attachment.file" target="_blank">
                <div class="attachment-file rounded" :title="attachment.name" v-bind:style="{ backgroundImage: 'url(' + getAttachmentImage(attachment) + ')' }"></div>
              </a>
            </div>
            <b-col>
              <nl2br tag="p" :text="attachment.name" class-name="mb-0" />
            </b-col>
          </b-row>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FormField',
    props: {
      field: {
        type: Object,
        required: true
      },
      readonly: {
        type: Boolean,
        default: false
      },
      preview: {
        type: Boolean,
        default: false
      },
      printable: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        datePickerOptions: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          locale: 'pt-br'
        }
      }
    },
    methods: {
      getFieldOptions(field) {
        return (field.options.indexOf(';') > -1)?field.options.split(';'):(field.options != '')?[ field.options ]:[];
      },

      addAttachment(field) {
        if(!field.value)
          field.value = [];
        field.value.push({name:'',value:'',file:null,file_name:'',selected_file:''});
      },

      attachmentChanged(field, index) {
        let attachment = field.value[index];
        attachment.file = null;
        attachment.file_name = '';
        if (attachment.selected_file) {
          attachment.file_name = attachment.selected_file.name;
          const reader = new FileReader();
          reader.onload = (event) => {
            attachment.file = event.target.result;
          };
          reader.readAsDataURL(attachment.selected_file);
        }
      },

      removeAttachment(field, index) {
        field.value.splice(index, 1);
      },

      getAttachmentImage(attachment) {
        let imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
        if(attachment && attachment.file_name) {
          let extension = attachment.file_name.split('.').pop();
          if(imageExtensions.indexOf(extension) > -1)
            return attachment.file;
        }
        return require('@/assets/images/attachment.png');
      }
    }
  }
</script>

<style scoped lang="scss">
  .cj-form-field {
    .form-control {
      &.auto-height {
        height: auto;
      }
    }

    .checkbox {
      border: 1px solid #000000;
      width: 15px;
      height: 15px;
      display: inline-block;
      margin: 5px 10px 5px 0;
      position: relative;
      background-color: transparent;

      &.filled:after {
        width: 1px;
        height: 1px;
        background-color: #000000;
        outline: 4px solid #000000;
        display: inline-block;
        top: 6px;
        left: 6px;
        position: absolute;
        content: ' ';
      }
    }

    .custom-file {
      font-size: 14px;
    }

    .attachment-container {
      position: relative;

      .attachment-file {
        margin-left: 15px;
        width: 80px;
        height: 80px;
        background: #f0f0f0 no-repeat 50%;
        background-size: contain;
        border: 1px solid $linkWater;
      }
    }
    @media print {
      .attachment-label {
        margin-bottom: 10px;
      }

      .attachment-container {
        margin-bottom: 15px;

        .attachment-file {
          width: 70px;
          height: 70px;
        }
      }
    }
  }
</style>
